/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Checkbox Service User Denied component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { ReactNode } from 'react';

import { Checkbox } from '../../../components/common';
import { ICheckboxProps } from '../../../components/common/Checkbox/Checkbox';
import ServiceUserDenied from './ServiceUserDenied';
import { CheckboxServiceUserDeniedStyled } from './styled/CheckboxServiceUserDeniedStyled';

interface ICheckboxServiceUserDenied extends ICheckboxProps {
    children: ReactNode;
}

const CheckboxServiceUserDenied = (props: ICheckboxServiceUserDenied) => {
    const { children, ...checkboxProps } = props;

    return (
        <ServiceUserDenied renderComponent={disabled =>
            <CheckboxServiceUserDeniedStyled disabled={disabled}>
                <Checkbox {...checkboxProps} disabled={disabled || checkboxProps.disabled}/>
                {children}
            </CheckboxServiceUserDeniedStyled>
        }/>
    );
};

CheckboxServiceUserDenied.defaultProps = {
    checked: false,
    disabled: false,
    kind: 'normal',
    label: '',
    onChange: () => {
    },
};

export default CheckboxServiceUserDenied;
